const howItWorksSection = document.querySelector(".how-it-works");
const howItWorksText = document.querySelector(".how-it-works__text-content");
const metabolismContainer = document.querySelector(
  ".how-it-works-metabolism__row:last-of-type"
);
const metabolismPercentContainers = document.querySelectorAll(
  ".how-it-works-metabolism__percentage > div"
);
const metabolismSlider = document.querySelector(".how-it-works__slider");

const textObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        [...howItWorksText.children].forEach((child) => fadeInCallback(child));
        textObserver.unobserve(howItWorksText);
      }
    });
  },
  {
    threshold: 0.3,
  }
);

const graphObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        [...metabolismPercentContainers].forEach((child) =>
          metabolismGraphCallback(child)
        );
        graphObserver.unobserve(metabolismContainer);
      }
    });
  },
  {
    threshold: 0.2,
  }
);

const sliderObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        fadeInCallback(metabolismSlider);
        sliderObserver.unobserve(metabolismSlider);
      }
    });
  },
  {
    threshold: 0.1,
  }
);

textObserver.observe(howItWorksText);
if (metabolismSlider) {
  sliderObserver.observe(metabolismSlider);
}
graphObserver.observe(metabolismContainer);

function fadeInCallback(el) {
  el.classList.add("fade-in");
}

function metabolismGraphCallback(el) {
  const percentNumber = Number(el.children[0].innerText.split("%")[0]);

  el.parentElement.classList.add("scroll-down");

  setTimeout(() => animateCountUp(el.children[0], percentNumber), 600);
}
